import * as React from "react";
import { Progress as ProgressPrimitive } from "@/shared/ui/components/ui/progress";
import { cn } from "@/shared/lib/utils";

export interface ProgressProps
  extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive> {
  value: number;
  showLabels?: boolean;
  labelClassName?: string;
  className?: string;
  progressClassName?: string;
}

export const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive>,
  ProgressProps
>(({ value, showLabels = true, labelClassName, className, progressClassName, ...props }, ref) => {
  const displayValue = Math.min(Math.max(value || 0, 0), 100);

  return (
    <div className={cn("w-full space-y-2", className)}>
      {showLabels && (
        <div className="flex justify-between items-center">
          <span
            className={cn(
              "text-xxs  font-semibold text-grey-900",
              labelClassName
            )}
          >
            {displayValue}%
          </span>
          <span
            className={cn(
              "text-xxs font-semibold text-grey-900",
              labelClassName
            )}
          >
            100%
          </span>
        </div>
      )}
      <ProgressPrimitive
        ref={ref}
        value={displayValue}
        {...props}
        progressClassName={progressClassName}
      />
    </div>
  );
});

Progress.displayName = "Progress";
